import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75707771"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full max-w-500 mx-auto lg:w-3/4 lg:max-w-800" }

import { computed } from 'vue';
import MediaHandler from '@/shared/content/blocks/helpers/MediaHandler.vue';
import { UspTileModel } from '@/types/B2BcontentServerContract';
import Swiper from '@/shared/Swiper.vue';
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';
import RouterLinkConditional from '@/core/navigation/router-link-conditional.vue';
import { SwiperOptions } from 'swiper';


export default /*#__PURE__*/_defineComponent({
  __name: 'USPTileRibbon',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as {
    content:UspTileModel
}



const backgroundColor = computed<string>(() => {
    return props.content.backgroundColorHexCode ? props.content.backgroundColorHexCode : 'transparent';
});
const textColor = computed<string>(() => {
    return props.content.sliderArrowColorHexCode ? props.content.sliderArrowColorHexCode : '';
});
const styles = computed(() => {
    return {
        backgroundColor: backgroundColor.value,
    };
});
const navigationStyles = computed(() => {
    return {
        color: textColor.value,
    };
});
const slides = computed(() => {
    const array: any = [];
    let currentPos = -1;
    const itemsPrChunk = isMobile.value || isTablet.value ? 2 : 4;

    props.content.items.forEach((tile: any, index: number) => {
        if (index % itemsPrChunk === 0) {
            currentPos++;
        }
        Array.isArray(array[currentPos]) ? array[currentPos].push(tile) : array[currentPos] = [tile];
    });

    return array;
});
const isMobile = computed(() => breakpointsState.activeBreakpoint === 'xs');
const isTablet = computed(() => breakpointsState.activeBreakpoint === 'sm');
const swiperOptions = computed<Partial <SwiperOptions>>(() => {
    return {
        spaceBetween: 40,
        centerInsufficientSlides: true,
        slidesPerGroup: 1,
        slidesOffsetBefore: 1,
        slidesOffsetAfter: 0,
        navigation: true,
        pagination: false,
    };
});

return (_ctx: any,_cache: any) => {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([' mb-gutter flex items-center py-2']),
    style: _normalizeStyle(_unref(styles))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Swiper, {
        "nav-style": _unref(navigationStyles),
        options: _unref(swiperOptions),
        class: "c-usp-swiper mt-18 px-50 md:px-48"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slides), (slide, idx) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, {
              key: idx,
              class: "flex"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slide, (item, itemIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: itemIndex,
                    class: "px-25 md:px-25 w-1/2 md:w-1/4"
                  }, [
                    _createVNode(RouterLinkConditional, {
                      to: item.link?.url,
                      target: item.link?.target,
                      "spa-enabled": item.link?.spaLink,
                      class: "block aspect-ratio-1x1"
                    }, {
                      default: _withCtx(() => [
                        (item.icon)
                          ? (_openBlock(), _createBlock(MediaHandler, {
                              key: 0,
                              "image-width-on-screen": { xs: 10, sm: 10, md: 14, lg: 14 },
                              "media-block": item.icon,
                              "image-alt-text-override": item.title
                            }, null, 8, ["media-block", "image-alt-text-override"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["to", "target", "spa-enabled"])
                  ]))
                }), 128))
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["nav-style", "options"])
    ])
  ], 4))
}
}

})